import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { BoardColumn, BoardEmpty } from "@/components/admin/LeadBoardLayout";

const COLUMN_PLACEHOLDERS = ["new", "contacted", "awaiting", "won", "lost"];

/** The five stage columns, or whatever is standing in for them right now. */
export const BoardColumns = ({ board }) => {
  if (board.loading) {
    return (
      <div className="mt-5 grid grid-cols-1 gap-3 lg:grid-cols-5">
        {COLUMN_PLACEHOLDERS.map((key) => (
          <Skeleton key={key} className="h-72 w-full" />
        ))}
      </div>
    );
  }

  if (!board.board) {
    return (
      <div className="py-16 text-center text-sm text-muted-foreground">
        We couldn&apos;t load the board.
        <Button
          type="button"
          variant="outline"
          onClick={() => board.load()}
          className="ml-3 bg-white"
        >
          Try again
        </Button>
      </div>
    );
  }

  if (board.allCards.length === 0) return <BoardEmpty filtered={board.filtered} />;

  const { drag } = board;
  return (
    <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
      {board.board.columns.map((column) => (
        <BoardColumn
          key={column.key}
          column={column}
          stages={board.stages}
          dragRef={drag.ref}
          isDropTarget={drag.target === column.key}
          onDragOver={(event) => drag.over(event, column.key)}
          onDragLeave={() => drag.leave(column.key)}
          onDrop={(event) => drag.drop(event, column.key)}
          onDragStart={drag.start}
          onOpen={board.setActive}
          onStageChange={board.moveTo}
        />
      ))}
    </div>
  );
};
